import { render, staticRenderFns } from "./create-edit-manage.vue?vue&type=template&id=5fbce0e9&scoped=true"
import script from "./create-edit-manage.vue?vue&type=script&lang=js"
export * from "./create-edit-manage.vue?vue&type=script&lang=js"
import style0 from "./create-edit-manage.vue?vue&type=style&index=0&id=5fbce0e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbce0e9",
  null
  
)

export default component.exports